/* eslint-disable camelcase */
import { useMutation } from '@tanstack/vue-query'
import type { RegisterVerifyEmailDTO } from '~/schemas/auth/register'
import type { RegisterResponse } from '~/types/auth'
import type { SuccessResponse } from '~/types/response'

const useRegister = () => {
  const { fetch } = useAPIFetch()
  const { login } = useSuccessfulLogin()
  const gtm = useGtm()

  return useMutation({
    mutationFn: (values: RegisterVerifyEmailDTO) =>
      fetch<SuccessResponse<RegisterResponse>>({
        method: 'POST',
        url: 'users',
        data: values,
      }),
    onSuccess: ({ data: { token, is_two_factor, user } }) => {
      gtm?.trackEvent({
        event: 'signup',
      })

      if (is_two_factor) {
        navigateTo({
          path: '/login/two-step-verification',
          query: {
            userId: user.id,
          },
        })

        return
      }

      login({
        token,
        remember: true,
        user,
      })
    },
  })
}

export default useRegister
